import BonanzaPageContainer from "../../Component/Reward/Bonanza/Bonanza"

const BonanzaPage = () => {
  return (
    <div className='page-body'>
      <BonanzaPageContainer />
    </div>
  )
}

export default BonanzaPage